<template>
  <DialogueBox
    data-auto-id="groupmember-delete-dialogue"
    :showing="showing"
    title="Confirm Deletion"
  >
    <div class="p-4">
      <p>Are you sure you want to remove this group member?</p>
      <dl class="mb-8">
        <dt data-auto-id="groupmember-delete-name" class="font-bold"></dt>
      </dl>
      <div class="flex items-center">
        <button
          data-auto-id="groupmember-delete-confirm"
          @click.prevent="$emit('confirm')"
          class="m-0 mr-4"
        >
          Confirm
        </button>
        <a
          href="#!"
          @click.prevent="$emit('cancel')"
          class="text-gray-darkest no-underline"
          >Cancel</a
        >
      </div>
    </div>
  </DialogueBox>
</template>

<script>
import DialogueBox from '@/Common/DialogueBox'
export default {
  name: 'GroupMemberDeleteDialogue',
  components: {
    DialogueBox,
  },
  props: {
    showing: Boolean,
    deleteQueue: Array,
  },
}
</script>
